import React, { Component } from 'react';
import {connect} from 'react-redux';
import warningIcon from '../../../assets/warning.svg';
import axios from '../../../axios';
import * as  url from './../../../utils/url';
import * as actionCreators from './../../../modules/actions/index';



class OfficeHierarchyManagementReview extends Component {

  constructor(props) {
    super(props);
    this.state = {
        staticHierarchy: this.props.user.profile.organizationId.staticHierarchy,
        availableOffices:[
          {value:"Engineer", label:"Engineer"},
          {value:"New Office", label:"New Office"}
        ],
        officeLength:3
    }
  }

  changeName=(value)=>{
    console.log(value)
    this.setState({newName:value.label})
  }


  submitHierarchyChange =()=>{
    // console.log("helllo changes!")
  let {temporaryHierarchy,updatedOffices}=this.props.orgChart
  
  // console.log(updatedOffices, this.props.orgChart)
  var that =this
  
  axios.all([
    // axios.post(url.changeOfficeNames, updatedOffices),
    axios.post(url.hierarchyNameChange, temporaryHierarchy),
  ])
  .then(axios.spread(function (offices, mapping) {
    that.props.saveOfficeHierarchy(temporaryHierarchy);
    that.props.saveDisabledOffices([])
    that.props.history.push('/home/enterprise-info/org-chart/management/success')
  }))

  // axios.post(url.changeOfficeNames, updatedOffices).then((data)=>{
  //   console.log(data)
  // }).catch(err =>{
  //   console.log(err)
  // })

    // axios.post(url.hierarchyNameChange, temporaryHierarchy).then((data)=>{
    //   console.log(data)
    //   this.props.saveOfficeHierarchy(temporaryHierarchy);
    //   this.props.saveDisabledOffices([])
    //   this.props.history.push('/home/enterprise-info/org-chart/management/success')
    // }).catch(err =>{
    //   console.log(err)
    // })

  }


  render() { 
    let {officeLength}=this.state
      console.log(this.state, this.props)
    let { updatedOffices}=this.props.orgChart
    // console.log(temporaryHierarchy)
    return ( 
      <div>
        <div className="mt30">
          <div className="title-text">
            Office Hierarchy Management
          </div>
        </div>
        <hr/>

        <div className="review-alert-msg-bg mt40 row">
          <i className="close-icon">close</i>
					<div className="d-flex custom-message-box">
          <img src={warningIcon} className="alert-i"/>
            <span className="ml10 alert-msg-text">
              
              <span className="newOfficesFoundTxt">
              These are your changes  
              </span>

              <p className="newOfficesFoundContent">Are you sure you want to change the following offices names ? </p>
            </span>
					</div>
				</div>

      {updatedOffices && updatedOffices.length>0?
          <table className="table table-responsive-lg text-primary-color tool-list-font" 
          style={{borderTop:'0px'}}>
          <thead className='bottom-border-color'>
            <tr className="row font-weight-bold text-secondary">
              <th className="border-none col-md-6 col-lg-6 data-mapping-table-header">
                Original Office Name
              </th>
              <th className="border-none col-md-6 col-lg-6 data-mapping-table-header">
                Updated Office Name
              </th>
            </tr>
          </thead>
          <tbody style={{maxHeight:'400px',overflowY:'auto',display:'block'}}>
          {
            updatedOffices.map((e,idx) => {
              return(
                <tr className="map-column-table row pl20 pr20" key={idx}
                  style={{borderTop:'0',borderBottom: '1px solid #E7E7E9'}}>
                  
                  <td className="col-md-6 col-lg-6">
                    {e.oldName}

                  </td>
                
                  <td className="col-lg-4 col-md-4">
                  {e.newName}
                    
                  </td>
                </tr>
            )})}
          </tbody>
        </table>
      :
        null
      }
        


            <span className="float-left officeHierarchyBackBtn btn btn-secondary-filled" onClick={()=>this.props.history.push(`/home/enterprise-info/org-chart/management/edit`)}>
                Go Back
              </span>


              <span className="float-right officeHierarchyContinueBtn btn btn-secondary" onClick={this.submitHierarchyChange}>
              Submit
              </span>
              
              
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  console.log(state)
  return {
    user : state.user,
    orgChart:state.orgChart
  }
}



const mapDispatchToProps = dispatch => {
	return {
    saveOfficeHierarchy : (c) => dispatch(actionCreators.saveOfficeHierarchy(c)),
    saveDisabledOffices: (disabledOffices) => dispatch(actionCreators.saveDisabledOffices(disabledOffices)),

	}
}

 
export default connect(mapStateToProps,mapDispatchToProps)(OfficeHierarchyManagementReview,axios);